'use strict'

export default class loginuser {
    constructor(
        datauser = "",
        password = ""
    ) {
        this.datauser = datauser
        this.password = password
    }

}